export default __webpack_public_path__ + "static/media/VPC.1861182b.svg";